import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxSpinner } from 'ngx-spinner/lib/ngx-spinner.enum';
import { AddDriverService } from './add-driver.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-drivers',
  templateUrl: './add-drivers.component.html',
  styleUrls: ['./add-drivers.component.sass']
})
export class AddDriversComponent implements OnInit {
  fName="";
  lName="";
  emailId="";
  mobileNumber =""; 
  vehicleCity="";
  vehicleState="";
  cityLatitude="";
  cityLongtitude="";
  source="";
  vehicleType="";
  nameAsPerBank="";
  bankAccountNumber="";
  ifscCode="";
  bankName="";
  upiMobileNumber="";
  paymentApp="";
  upiID="";
  vehicleNumber="";
  allVehiclesList:any=[];
  isControlledByAdmin:boolean=false;
  homeStopLocation:"";
  homeStopLat:"";
  homeStopLng:"";
  homeStop:"";


  constructor(private spinner : NgxSpinnerService , 
              private driverService : AddDriverService,
              private toastr : ToastrService ) { }

  ngOnInit(): void {
    this.getVehicles();
  }



  getVehicles(){
    this.spinner.show();
      let data ={"currentStatus":1,"isDeleted":0}
      this.driverService.getAllvehicles(data).subscribe((result:any)=>{
        if(result.statusCode == 200){
          this.spinner.hide()
          console.log(result)
          this.allVehiclesList = result.data.filter((vehicle:any) => vehicle.currentStatus !== 0)
        }else{
          this.spinner.hide();
          this.allVehiclesList =[]
        }
      })
}


adddriver(){
  this.spinner.show();
  console.log(this.isControlledByAdmin)
  let data = {
    firstName : this.fName,
    lastName : this.lName,
    emailId : this.emailId ,
    city : this.vehicleCity ,
    phoneNumber : this.mobileNumber , 
    currentLatitude : this.cityLatitude , 
    currentLongitude : this.cityLongtitude,
    homeStopLocation : this.homeStop,
    homeStopLat : this.homeStopLat,
    homeStopLng : this.homeStopLng,
    isControlledByAdmin:this.isControlledByAdmin,
    // ipAddress
    vehicleType:this.vehicleType,
    nameAsPerBank:this.nameAsPerBank,
    bankAccountNumber:this.bankAccountNumber,
    ifscCode:this.ifscCode,
    bankName:this.bankName,
    upiMobileNumber:this.upiMobileNumber,
    paymentApp:this.paymentApp,
    upiID:this.upiID,
    vehicleNumber:this.vehicleNumber
  }
  console.log(data)
  this.driverService.addDriver(data).subscribe((result:any)=>{
    if(result.statusCode == 200){
      this.spinner.hide()
      this.toastr.success(result.message);
      this.fName="";
      this.lName="";
      this.emailId="";
      this.mobileNumber ="";
      this.vehicleCity="";
      this.vehicleState="";
      this.cityLatitude="";
      this.cityLongtitude="";
      this.homeStopLocation="";
      this.homeStopLat="";
      this.homeStopLng="";
      this.source="";
      this.vehicleType="";
      this.paymentApp="";
      this.upiMobileNumber="";
      this.nameAsPerBank="";
      this.bankAccountNumber="";
      this.ifscCode="";
      this.bankName="";
      this.upiID="";
      this.vehicleNumber="";
    }else{
      this.spinner.hide();
      this.toastr.error(result.message)
    }
  })
}






  getCityData(address:any){
  
    if(address.address_components.length == 3){
      this.vehicleState = address.address_components[1].long_name
      this.vehicleCity = address.address_components[0].long_name
    }else if(address.address_components.length == 4){
      this.vehicleState = address.address_components[2].long_name
      this.vehicleCity =  address.address_components[0].long_name
    }else if(address.address_components.length == 5){
      this.vehicleState = address.address_components[3].long_name
      this.vehicleCity = address.address_components[0].long_name
    }else if(address.address_components.length == 6){
      this.vehicleState = address.address_components[3].long_name
      this.vehicleCity = address.address_components[2].long_name
    }else if(address.address_components.length == 7){
      this.vehicleState = address.address_components[5].long_name
      this.vehicleCity = address.address_components[2].long_name
    }

    // let data = {
    //   "city" : this.vehicleCity,
    //   "state" : this.vehicleState,
    //   "country" : "India"
    // }
    // this.spinner.show()
    // this.addvehicelService.checkVerifyCity(data).subscribe((result:any)=>{
    //     if(result.statusCode == 200){
    //       this.spinner.hide();
          this.cityLatitude = address.geometry.location.lat()
          this.cityLongtitude = address.geometry.location.lng()
    //     }else{
    //       this.spinner.hide()
    //       this.cityLatitude = "";  
    //       this.cityLongtitude = "";
    //       this.toastr.error("City Not Verified");

    //     }
    // })


  }

  getHomeStopData(address:any){
    this.homeStop=address.formatted_address
    this.homeStopLat = address.geometry.location.lat()
    this.homeStopLng = address.geometry.location.lng()
  }

 
  

 



}

